
import { defineComponent } from 'vue'
import RedirectEvents from './RedirectEvents.vue'
import AffiliateLogs from './AffiliateLogs.vue'

import { heroOutline24ArrowDownTray } from 'quasar-extras-svg-icons/hero-icons-v2'
export default defineComponent({
  name: 'Logs',
  components: { RedirectEvents, AffiliateLogs },
  setup() {
    return {
      heroOutline24ArrowDownTray,
    }
  },
  data: function() {
    return {
      tab: 'clicks',
    }
  },
  methods: {
    backToStats() {
      const params = JSON.parse(this.$route.params.filters as any)
      this.$router.push({
        name: 'statistics',
        params: {
          filters: this.$route.params.filters,
          ...('vertical' in params ? { vertical: params.vertical } : {}),
        },
      })
    },
  },
})
